import React from 'react';

const SelectItem = ({ isDisabled, children, onClick }) => {
  return (
    <div disabled={isDisabled} onClick={onClick} className="cursor-pointer hover:bg-gray-200 p-2">
      {children}
    </div>
  );
};

SelectItem.displayName = 'SelectItem';
export default SelectItem;
